import React from 'react';
import ServicesSection from '../components/ServicesSection';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="services-page">
      <section className="page-header">
        <div className="header-background">
          <div className="glow-orb glow-orb-1"></div>
          <div className="glow-orb glow-orb-2"></div>
          <div className="glow-orb glow-orb-3"></div>
        </div>
        <div className="header-container">
          <h1>{t('services.title')}</h1>
          <p>{t('services.subtitle')}</p>
        </div>
      </section>

      <ServicesSection isFullPage={true} />
    </div>
  );
};

export default Services;
